export var App;
(function (App) {
    App[App["Forms"] = 0] = "Forms";
    App[App["LiveChat"] = 1] = "LiveChat";
    App[App["Plugin"] = 2] = "Plugin";
    App[App["PluginSettings"] = 3] = "PluginSettings";
    App[App["Background"] = 4] = "Background";
})(App || (App = {}));
export const AppIframe = {
    [App.Forms]: 'integrated-form-app',
    [App.LiveChat]: 'integrated-livechat-app',
    [App.Plugin]: 'integrated-plugin-app',
    [App.PluginSettings]: 'integrated-plugin-app',
    [App.Background]: 'integrated-plugin-proxy',
};
